import { IUserPreferenceDataRequest } from "../context/types";

export function GetUserPreferenceDataRequestApiHelper(requestData: IUserPreferenceDataRequest): any {
    let isChangeAutoUpdate: boolean
    if (requestData?.horaIni != null || requestData?.periodo != null || requestData?.ordem != null) {
        isChangeAutoUpdate = false;
    } else if (requestData?.autoUpdate != null) {
        isChangeAutoUpdate = requestData?.autoUpdate;
    }
    else {
        isChangeAutoUpdate = requestData?.userPreference.ChangeAutoUpdate;
    }
    let userDataRequest: any = {};
    userDataRequest = Object.assign(userDataRequest, requestData?.userPreference); 
    userDataRequest.UserAutoScroll = requestData?.userPreference.ChangeAutoUpdate;
    
    userDataRequest.Data = requestData?.data ?? requestData?.userPreference.Data.split('T')[0];
    userDataRequest.HorarioIni = requestData?.horaIni ?? requestData?.userPreference.HorarioIni;
    userDataRequest.Horario = requestData?.hora ?? requestData?.userPreference.Horario;
    userDataRequest.Language = {
        Id: requestData?.idLanguage ?? requestData?.userPreference.Language.Id
    };
    userDataRequest.Periodicidade = {
        Id: requestData?.periodo ?? requestData?.userPreference.Periodicidade.Id
    };
    userDataRequest.Praca = requestData?.praca ?? requestData?.userPreference.Praca;
    userDataRequest.Target = {
        Id: requestData?.target ?? requestData?.userPreference.Target.Id
    };
    userDataRequest.Indice = requestData?.indice ?? requestData?.userPreference.Indice;
    userDataRequest.Ordenacao = requestData?.ordem ?? requestData?.userPreference.Ordenacao;
    userDataRequest.Country = {
        CountryID: requestData?.userPreference.Country.CountryID
    };
    userDataRequest.PracaImagem = {};
    userDataRequest.ChangeAutoUpdate = isChangeAutoUpdate;
    userDataRequest.TipoBase = requestData?.tipoBase ?? requestData?.userPreference.TipoBase; 

    return userDataRequest;
}

